<template>
	<div class="col-12 table-wrapper-list" v-show="list.length > 0">
		<table class="table table-striped">
			<thead>
				<tr>
					<td>
						<input
							type="checkbox"
							v-model="allCheck"
							:key="`check-all`"
						>
					</td>
					<td>Felelős</td>
					<td>Határidő</td>
					<td>Ügyfél</td>
					<td>Rövid leírás</td>
					<td>Telefonszám</td>
					<td>Módosítás</td>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(v,k) in list"
					:key="`list-${k}`"
				>
					<td>
						<input
							type="checkbox"
							v-model="v.check"
							:id="`c-${k}`"
							:key="`check-${k}`"
						>
					</td>
					<td>
						{{v.user}}
					</td>
					<td>
						{{v.hatarido}}
					</td>
					<td>
						{{v.ugyfel}}
					</td>
					<td
						v-tooltip="v.feladat"
					>
						{{v.feladat_rovid}}
					</td>
					<td>
						<p v-if="v.feladat_rovid.includes('Érdeklődő')">
							{{ v.telm }}  {{ v.telv }}
						</p>
					</td>
					<td>
						<router-link
							tag="a"
							class="btn btn-outline-primary"
							:to="`/tasks/edit/${v.id}`"
							target="_blank"
						>
							Módosít
						</router-link>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['list'],

	data() {
		return {
			allCheck: false
		}
	},

	watch: {
		allCheck() {
			let arr = []
			this.list.map(x => {
				x.check = this.allCheck
				arr.push(x.id)
			})
			this.$emit("checkedChange", arr)
		},

		list: {
			handler() {
				let arr = []
				this.list.map(x => {
					if(x.check) arr.push(x.id)
				})
				this.$emit("checkedChange", arr)
			},
			deep: true
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/tasks/taskList.vue